import { connect } from 'react-redux';
import i18next from 'i18next';
import React, { useEffect, useState } from 'react';

import { StyledHeaderRow, StyledTable, StyledTableRow } from './styledComponents';

import { TableBody, TableCell, TableHead, IconButton, Tooltip } from '@mui/material';

import { showErrorMessage, showSuccessMessage } from '@actions/messageconfirmation';

import { publicKeysService } from '@services/backoffice/publicKeys';

const PublicApiKeysTable = (props) => {
  const { showErrorMessage, showSuccessMessage, onEdit, refreshKey } = props;

  const [apiKeys, setApiKeys] = useState([]);

  useEffect(() => {
    const loadApiKeys = async () => {
      try {
        const result = await publicKeysService.getApiKeysByClientId();
        setApiKeys(result);
      } catch {
        showErrorMessage(i18next.t('ADMIN.INTEGRATIONS.PUBLIC_API_KEYS.FETCH_LIST_FAILURE'));
        setApiKeys([]);
      }
    };
    loadApiKeys();
  }, [refreshKey, showErrorMessage]);

  if (!apiKeys.length) {
    return null;
  }

  return (
    <StyledTable>
      <TableHead>
        <StyledHeaderRow>
          <TableCell component="th">
            {i18next.t('ADMIN.INTEGRATIONS.PUBLIC_API_KEYS.NAME_LABEL')}
          </TableCell>
          <TableCell component="th">
            {i18next.t('ADMIN.INTEGRATIONS.PUBLIC_API_KEYS.APIKEY_LABEL')}
          </TableCell>
        </StyledHeaderRow>
      </TableHead>
      <TableBody>
        {apiKeys.map((key) => (
          <StyledTableRow key={key.id}>
            <TableCell>{key.lastName}</TableCell>
            <TableCell>{key.apiKey}</TableCell>
            <TableCell align="right">
              <Tooltip title="copy">
                <IconButton
                  onClick={() =>
                    navigator.clipboard
                      .writeText(key.apiKey)
                      .then(() => {
                        showSuccessMessage(
                          i18next.t('ADMIN.INTEGRATIONS.PUBLIC_API_KEYS.COPY_SUCCESS'),
                        );
                      })
                      .catch(() => {
                        showErrorMessage(
                          i18next.t('ADMIN.INTEGRATIONS.PUBLIC_API_KEYS.COPY_FAILURE'),
                        );
                      })
                  }
                >
                  <img alt="copy" height={16} src="/images/inpulse/content-copy.svg" width={16} />
                </IconButton>
              </Tooltip>
              <Tooltip title="update">
                <IconButton onClick={() => onEdit(key)}>
                  <img
                    alt="edit"
                    height={16}
                    src="/images/inpulse/pen-black-small.svg"
                    width={16}
                  />
                </IconButton>
              </Tooltip>
            </TableCell>
          </StyledTableRow>
        ))}
      </TableBody>
    </StyledTable>
  );
};

const mapDispatchToProps = (dispatch) => ({
  showErrorMessage: (message) => dispatch(showErrorMessage(message)),
  showSuccessMessage: (message) => dispatch(showSuccessMessage(message)),
});

export default connect(null, mapDispatchToProps)(PublicApiKeysTable);
